import React, { useEffect, useState } from 'react';
import { Colors } from 'library';
import { Snackbar } from '@mui/material';
import { useLocation } from 'react-router';
import { PillButton } from 'library/ui';
import { stopImpersonating } from 'shared/impersonation';
import useWindowFocus from 'shared/WindowFocus';

export default function ImpersonationButton() {
    const pathname = useLocation().pathname;
    const [snackOpen, setSnackOpen] = useState(false);
    const [impersonating, setImpersonating] = useState(false);

    function stop() {
        stopImpersonating();
        window.$chatwoot?.reset();
        window.close();
    }

    function onFocus() {
        if (impersonating && !localStorage.getItem('old')) {
            setImpersonating(false);
            setSnackOpen(true);
        }
    }

    useWindowFocus(onFocus, [impersonating]);

    useEffect(() => {
        if (localStorage.getItem('old')) setImpersonating(true);
    }, [pathname]);

    return (
        <>
            {impersonating ? (
                <PillButton color={Colors.secondary} onClick={stop}>
                    Stop Impersonating
                </PillButton>
            ) : null}
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                open={snackOpen}
                onClose={() => setSnackOpen(false)}
                message="It looks like you're no longer impersonating in this tab. Would you like to close it?"
                action={<PillButton onClick={window.close}>Close</PillButton>}
            />
        </>
    );
}
